<script>

import axios from 'axios';


	import { onMount, onDestroy } from 'svelte';

	import { link, push } from 'svelte-spa-router'

	import { createEventDispatcher } from 'svelte';

	import { account_service       , account_service_context_key        } from './_services/account.js';
   import { loggedIn                                                   } from './_services/accountsession.js';
	import { cookiejar_service     , cookiejar_service_context_key      } from './_services/cookiejar.js';
	
	const dispatch = createEventDispatcher();

	let user_credentials = {
		uname: 'ada@lovelace.com',
		psw: 'secret'
	};


    function handleSubmit(event) {
//        console.log(event);
//        console.log(event.target);
//        console.log(event.target.uname.value);
//        console.log(event.target.psw.value);
//        console.log(user_credentials.uname);
//        console.log(user_credentials.psw);

        loginWithEmailPassword(user_credentials.uname, user_credentials.psw,
        					function (res) { /*on-success handler*/
							   alert('logged in');
								
							   // bubble up the login event
								dispatch('sessionEvent', {
										'loggedIn': loggedIn
									});

							   // set window url by pushing new location
								push('/applist/'); 
        					}, 
        					function (err) {/*on-error handler*/}
        		) ;

    }

	onMount(async () => {

	});


	async function setCookie() {
		alert('function setCookie()')
	
			const response = await fetch("https://auth.artificiality.be/setcookie",
			{
			    method: 'POST',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'Accept': 'application/vnd.artificiality.auth.accountsession-v1+json',
			        'Content-Type': 'application/json',
//			        'Authorization': 'Bearer '+ cookies.get('JWT'),		        
			    },
			    body: JSON.stringify({cookie_name: "foo", cookie_value: "bar" }),
			})
			.then((response) => response.json())
			.then((data) => { })
			.catch((err) => { })
			;
	
   }

	async function getCookie() {
		alert('function getCookie()')
			const response = await fetch("https://auth.artificiality.be/getcookie",
			{
			    method: 'POST',
			    credentials: 'include',    // omit | include | same-origin
			    headers: {
			        'Accept': 'application/vnd.artificiality.auth.accountsession-v1+json',
			        'Content-Type': 'application/json',
//			        'Authorization': 'Bearer '+ cookies.get('JWT'),		        
			    },
			    body: JSON.stringify({ cookie_name: "foo" }),
			})
			.then((response) => response.json())
			.then((data) => {   })
			.catch((err) => {   })
			;

   }

	onDestroy(() => { 
	});

    
</script>

<style>
</style>


<form on:submit|preventDefault="{handleSubmit}">
  <div class="img-container">
    <!--img src="img_avatar2.png" alt="Avatar" class="avatar"-->
  </div>

  <div class="form-container">
    <label for="uname"><b>Username</b></label>
    <input type="text" id="myInputUname" name="uname" bind:value={user_credentials.uname} placeholder="Enter Username" required>

    <label for="psw"><b>Password</b></label>
    <input type="password" id="myInputPsw" name="psw" bind:value={user_credentials.psw} placeholder="Enter Password" required>

    <button type="submit" id="myBtn">Login</button>
    <label>
      <input type="checkbox" checked="unchecked" name="remember"> Remember me
    </label>
  </div>

  <div class="container" style="background-color:#f1f1f1">
<!--
    <button type="button" class="cancelbtn">Cancel</button>
-->
    <span>Forgot <a href="/login" use:link>password?</a></span>
  </div>
</form> 


<!--
<button type="button" id="setCookie" on:click={setCookie}>setCookie</button>
<button type="button" id="getCookie" on:click={getCookie}>getCookie</button>
-->


